module.exports = __webpack_public_path__ + "img/awards_5.aa7f3d22.png";